import { useCallback } from "react";

import { UpdateEventFeedbackInput } from "../../../../common/types/events/api";
import { EventViewModel } from "../../models/eventViewModel";
import EventFeedbackDetails from "./EventFeedbackDetails";
import { FeedbackType } from "../../../../API";

interface EventFeedbackDetailsProps {
  event: EventViewModel;
  onUpdateEventFeedback: (input: UpdateEventFeedbackInput) => void;
}

const FeedbackDetailsTableCellContainer = ({
  event,
  onUpdateEventFeedback,
}: EventFeedbackDetailsProps) => {
  if (!event.feedback || event.feedback === FeedbackType.NEGATIVE) {
    return null;
  }

  const memoizedUpdateEventFeedbackDetails = useCallback(
    (mitigatedRisk: string[] | null) => {
      const input: UpdateEventFeedbackInput = {
        pk: event.customerId,
        sk: event.id,
        feedback: event.feedback?.toString() ?? null,
        mitigatedRisk: mitigatedRisk ? mitigatedRisk.join(";") : null,
      };

      onUpdateEventFeedback(input);
    },
    [event.mitigatedRisk]
  );

  const feedbacks = event.mitigatedRisk;

  return (
    <EventFeedbackDetails
      feedbacks={feedbacks}
      onAdd={memoizedUpdateEventFeedbackDetails}
      onEdit={memoizedUpdateEventFeedbackDetails}
    />
  );
};

export default FeedbackDetailsTableCellContainer;
